export var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["MOBILE"] = 375] = "MOBILE";
    Breakpoints[Breakpoints["TABLET"] = 768] = "TABLET";
    Breakpoints[Breakpoints["LAPTOP"] = 1024] = "LAPTOP";
    Breakpoints[Breakpoints["DESKTOP"] = 1280] = "DESKTOP";
})(Breakpoints || (Breakpoints = {}));
